const openChatwoot = (): void => {
    if (window.$chatwoot?.hasLoaded) {
        window.$chatwoot.toggle('open')
        return
    }

    const onReady = (): void => {
        window.$chatwoot?.toggle('open')
        window.removeEventListener('chatwoot:ready', onReady)
    }

    window.addEventListener('chatwoot:ready', onReady)
}

export default openChatwoot
